import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'appointment-date-time',
	templateUrl: './appointment-date-time.component.html',
	styleUrls: ['./appointment-date-time.component.scss'],
})
export class AppointmentDateTimeComponent {
	@Input() minDate;
	@Input() dates;
	@Input() index;
	@Output() onChangeTime = new EventEmitter();
	@Output() onChangeDate = new EventEmitter();
	@Output() onRemove = new EventEmitter();

	constructor() {}
}
